export default {
  'forms.validation.enter_valid_url': 'Please enter a valid URL',
  'forms.validation.enter_domain_name': 'Please enter a domain name',
  'forms.validation.enter_api_base_url': 'Please enter an API Base URL',
  'forms.validation.enter_aws_access_key_id':
    'Please enter an AWS Access Key ID',
  'forms.validation.enter_aws_secret_access_key':
    'Please enter an AWS Secret Access Key',
  'forms.validation.enter_authentication_url':
    'Please enter an Authentication Endpoint URL',
  'forms.validation.enter_aws_iam_role_arn': 'Please enter a valid ARN',
  'forms.validation.enter_header_key': 'Please enter a header key',
  'forms.validation.enter_header_value': 'Please enter a header value',
  'forms.validation.enter_status_check_name':
    'Please enter a name for this Health Check',
  'forms.validation.enter_monitor_url': 'Please enter a Monitor URL',
  'forms.validation.enter_observability_tool_name':
    'Please enter a name for this Observability Tool',
  'forms.validation.enter_healthy_status_code':
    'Please enter a value for a healthy status code',
  'forms.validation.enter_request_timeout':
    'Please enter a value for request timeout',
  'forms.validation.error.empty_aws_iam_role_arn':
    'IAM Role ARN cannot be empty',
  'forms.validation.error.aws_iam_role_arn.account_id_mismatch':
    'The Account ID in this ARN does not match the Account ID for this authentication. Please create a new AWS authentication to use a different Account ID.',
  'forms.validation.error.invalid_url': 'URL is not valid',
  'forms.validation.error.url_already_in_use': 'URL is already in use',
  'forms.validation.error.empty_domain_name': 'Domain name cannot be empty',
  'forms.validation.error.duplicate_header_key': 'Header key already exists',
  'forms.validation.error.empty_header_key': 'Header key cannot be empty',
  'forms.validation.error.empty_header_value': 'Header value cannot be empty',
  'forms.validation.error.empty_status_check_name':
    'Health Check name cannot be empty',
  'forms.validation.error.empty_observability_tool_name':
    'Observability Tool name cannot be empty',
  'forms.validation.error.name_already_exists': 'Name already used',
  'forms.validation.error.monitor_url_already_exists':
    'Health Check URL is already configured for the selected Observability Tool',
  'forms.validation.error.invalid_healthy_status_code':
    'Use a single status code (200) or a range (200-299)',
  'forms.validation.error.invalid_request_timeout':
    'Request timeout must be between 50 and 5000',
  'forms.validation.select_domain': 'Please select a domain',
  'forms.validation.enter_aws_account_id': 'Please enter an AWS Account ID',
  'forms.validation.enter_aws_account_id.error.already_in_use':
    'Account ID already in use',
  'forms.validation.enter_aws_account_id.error.length':
    'Please enter a valid AWS Account ID (must be exactly 12 digits long)',
  'forms.validation.select_observability_tool':
    'Please select an Observability Tool',
  'forms.validation.active_days.required':
    'At least one active day must be selected',
  'forms.validation.start_time_required': 'Start time is required',
  'forms.validation.end_time_range':
    'End time must be between {{minimum}} and {{maximum}} hours after start time'
}
